module.exports = __webpack_public_path__ + "static/media/Indorse白皮书+1.1版（节选）.1e615160.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/brand/Indorse白皮书+1.1版（节选）.pdf
// module id = 1281
// module chunks = 147